import CategoryType from 'owa-service/lib/contract/CategoryType';
import { ColorScheme } from 'mini-color/lib/schema/ColorScheme';
import { getColorSchemeFromPrimaryColor } from 'mini-color/lib/utils/colorSchemeGenerator';
import {
    getHexColorCodeForCategory,
    getDefaultHexColorCodeForCategory,
} from '../api/getHexColorCodeForCategory';

/**
 * Returns the color scheme for a given calendar
 * @param category
 */
export const getColorSchemeForCategory = (category: CategoryType): ColorScheme =>
    getColorSchemeFromPrimaryColor(getHexColorCodeForCategory(category));

/**
 * Gets the default category color scheme
 */
export const getDefaultColorSchemeForCategory = (): ColorScheme =>
    getColorSchemeFromPrimaryColor(getDefaultHexColorCodeForCategory());
